/**
 * Einstellungen → Firma → Vorfreude-Mail (Buchungsstrecke C3, sql/597).
 *
 * Ein Schalter, Vorgabe AUS: zwei Wochen vor der Veranstaltung schlägt MAESTRO eine Mail
 * „Ihr Fest rückt näher“ vor (Gästezahl-Frist, Ansprechpartner). Sie liegt unter „Freigaben“; es gilt
 * der Freigabemodus des Betriebs wie bei jeder anderen Automatik-Mail. Liefert den Wert über das
 * Feld `vorfreudeMailAktiv` an das umgebende Formular (Muster `GoogleBewertungEinstellung`).
 */
import { useState } from "react";
import { Toggle } from "./components";

export function VorfreudeMailEinstellung({ aktiv }: { aktiv: boolean | null | undefined }) {
  const [an, setAn] = useState(Boolean(aktiv));
  return (
    <div className="min-w-0 max-w-full rounded-xl border border-[#F0E7D6] px-4 py-4 dark:border-white/[0.06]" data-testid="vorfreude-mail-einstellung">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-body-md text-body-md font-semibold text-on-background dark:text-inverse-on-surface">Zwei Wochen vor der Veranstaltung eine Vorfreude-Mail vorschlagen</p>
          <p className="font-body-sm text-body-sm text-secondary dark:text-secondary-fixed-dim">
            „Ihr Fest rückt näher“: mit der Frist für die endgültige Gästezahl (falls Sie eine haben) und Ihrem Ansprechpartner. Der Vorschlag erscheint unter „Freigaben“; es gilt Ihr Freigabemodus wie bei den übrigen automatischen Mails. Nur bei zugesagten Veranstaltungen.
          </p>
        </div>
        <Toggle checked={an} onChange={setAn} label="Vorfreude-Mail vorschlagen" />
        <input type="hidden" name="vorfreudeMailAktiv" value={an ? "true" : "false"} />
      </div>
    </div>
  );
}
